
import MusicFilter from "../../../assets/duotone/MusicFilter.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MusicFilterIcon({ className, dataTestid = "MusicFilterIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MusicFilter data-testid={dataTestid} className={classes} {...rest} />
  );
}
